import { createFileRoute } from '@tanstack/react-router';
import { requireWorkstation } from '../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../pages/Loading/Loading';

const ChecklistsManual = lazy(() => import('../../../../pages/ChecklistsManual/ChecklistsManual'));

export const Route = createFileRoute('/$lang/_authenticated/checklists-manual')({
  beforeLoad: requireWorkstation,
  component: () => (
    <Suspense fallback={<Loading />}>
      <ChecklistsManual />
    </Suspense>
  ),
});
